import { CHANGE_EVENT, DEFAULT_MODE, LOG_LIMIT, MODES, STORAGE_KEYS } from './config';

const readJson = (key, fallback) => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    return fallback;
  }
};

const writeJson = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // localStorage mavjud bo'lmasa — jim o'tkazib yuboriladi
  }
  notifyChange(key);
};

export const notifyChange = (key) => {
  try {
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { key } }));
  } catch (error) {
    // eski brauzer
  }
};

export function readMode() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEYS.mode);
    return Object.values(MODES).includes(value) ? value : DEFAULT_MODE;
  } catch (error) {
    return DEFAULT_MODE;
  }
}

export function writeMode(mode) {
  if (!Object.values(MODES).includes(mode)) return;
  try {
    window.localStorage.setItem(STORAGE_KEYS.mode, mode);
  } catch (error) {
    // ignore
  }
  notifyChange(STORAGE_KEYS.mode);
}

export const readAttempts = () => readJson(STORAGE_KEYS.attempts, {});
export const writeAttempts = (attempts) => writeJson(STORAGE_KEYS.attempts, attempts);

export function updateAttempt(taskId, patch) {
  const attempts = readAttempts();
  attempts[taskId] = { count: 0, ...attempts[taskId], ...patch };
  writeAttempts(attempts);
  return attempts[taskId];
}

export const readLog = () => readJson(STORAGE_KEYS.log, []);

export function appendLog(entry) {
  const log = readLog();
  log.unshift(entry);
  writeJson(STORAGE_KEYS.log, log.slice(0, LOG_LIMIT));
}

export const clearLog = () => writeJson(STORAGE_KEYS.log, []);
